<template>
  <fragment>
    <b-modal
      :body-class="{ static: hoverTool }"
      id="modal-manage-header-topmenu"
      scrollable
      hide-footer
      no-close-on-esc
      no-close-on-backdrop
      v-if="siteComponents.HEADER_WIDGET_TOPMENU"
    >
      <template #modal-header>
        <div class="w-100">
          <div class="d-flex justify-content-between align-items-center">
            <TitleModal :label="$t('engine.manageHeader.widgetTopMenu.manageMenu.lblTitle', languageEngine)" />
            <div class="d-flex align-items-center">
              <div class="icon-question">
                <i class="fal fa-question-circle"></i>
              </div>
              <div
                @click="closeModal(), (text = ''), (expand_id = '')"
                type="button"
                aria-label="Close"
                id="close-modal-manage-header-topmenu"
                class="ml-gd-1 icon-close-modal"
              >
                <i class="fal fa-times"></i>
              </div>
            </div>
          </div>
          <div class="d-flex align-items-center pt-gd-2">
            <b-button variant="blue" class="btn-add-menu" @click="addMenu">
              <i class="fas fa-plus"></i>{{ " " }}{{$t('engine.manageHeader.widgetTopMenu.manageMenu.lblBtnAddMenu', languageEngine)}}</b-button
            >
            <div class="wrapper-search">
              <span class="icon-search">
                <i class="far fa-search"></i>
              </span>
              <b-form-input
                v-model="text"
                :placeholder="$t('engine.manageHeader.widgetTopMenu.manageMenu.lblPlaceholderSearchMenu', languageEngine)"
              />
              <span
                v-show="text !== ''"
                class="icon-clear-text"
                @click="text = ''"
              >
                <i class="fas fa-times-circle"></i>
              </span>
            </div>
          </div>
        </div>
      </template>

      <div class="wrapper-boby">
        <div class="wrapper-boby-inner">
          <div v-if="text !== ''" class="">
            {{$t('engine.manageHeader.widgetTopMenu.manageMenu.lblSearchResult', languageEngine)}} ({{ countSearch }})
            <hr class="mt-0 mb-15" />
          </div>
          <div
            class="text-center text-muted"
            v-if="countSearch === 0 && text !== ''"
          >
            {{$t('engine.manageHeader.widgetTopMenu.manageMenu.lblNoSearchResult', languageEngine)}}
          </div>
          <div id="nested-wrapper" v-if="displayData.length > 0">
            <VueNestable
              v-model="displayData"
              :class="{'pos-unset': expand_id}"
              children-prop="componentsID"
              @change="snap"
            >
              <template slot-scope="{ item, isChild }">
                <VueNestableHandle
                  :item="item"
                  v-if="checkShow(item.show)"
                  class="handler"
                >
                  <div id="panel-item" class="d-flex justify-content-between" :text="text"
                    :class="{
                      active: expand_id === `tools${item.id}`,
                      bactive: expand_id,
                      disabled: !item.properties.isEnable
                    }"
                  >
                    <div class="fs-sa-14">
                      <b-icon
                        class="icon-drag"
                        :class="{ 'text-muted': text !== '' }"
                        icon="three-dots-vertical"
                        variant="dark handle"
                      ></b-icon>
                      {{ item.properties.name }}
                    </div>
                    <span class="d-inline-flex text-muted">
                      <span
                        class="mr-2"
                        v-b-tooltip.hover
                        title="Hide Page"
                        v-if="item.properties.isEnable === false"
                      >
                        <i class="far fa-eye-slash"></i>
                      </span>
                      <div class="tool cursor-pointer">
                        <div
                          class="cursor-pointer tools-more-menu"
                          :id="`tools${item.id}`"
                          @click="fixExpand(item)"
                          :class="{active: expand_id === `tools${item.id}`}"
                        >
                          <i
                            class="fas fa-ellipsis-h text-muted mb-3 icon-more-menu"
                            style="pointer-events: none; font-size: 14px"
                          ></i>
                        </div>

                        <b-popover
                          :target="`tools${item.id}`"
                          triggers="click"
                          placement="rightbottom"
                          ref="popover"
                          :container="`tools${item.id}`"
                          content
                          boundary="viewport"
                        >
                          <div>
                            <div
                              class="cursor-pointer option fs-sa-14"
                              @click="editMenu(item.id, isChild, item.properties.isEnable)"
                            >
                              <span>
                                <i class="far fa-edit mr-8" style="font-size: 16px; width: 16px; height: 16px"></i>
                              </span>
                              {{$t('engine.manageHeader.widgetTopMenu.manageMenu.lblToolEditMenu', languageEngine)}}
                            </div>

                            <div
                              class="cursor-pointer option fs-sa-14"
                              @click="setStatus(item.id)"
                            >
                              <span v-show="item.properties.isEnable">
                                <i class="far fa-eye mr-8" style="font-size: 16px; width: 16px; height: 16px"></i>
                              </span>
                              <span v-show="!item.properties.isEnable">
                                <i class="far fa-eye-slash mr-8" style="font-size: 16px; width: 16px; height: 16px"></i>
                              </span>
                              {{ !item.properties.isEnable ? $t('engine.manageHeader.widgetTopMenu.manageMenu.lblToolShowMenu', languageEngine) : $t('engine.manageHeader.widgetTopMenu.manageMenu.lblToolHideMenu', languageEngine) }}
                            </div>

                            <div
                              class="cursor-pointer option fs-sa-14"
                              
                              @click="confirmDelete(item.id)" 
                            >
                              <span>
                                <i class="far fa-trash-alt mr-8" style="font-size: 16px; width: 16px; height: 16px"></i>
                              </span>
                              {{$t('engine.manageHeader.widgetTopMenu.manageMenu.lblToolDeleteMenu', languageEngine)}}
                            </div>
                          </div>
                        </b-popover>
                      </div>
                    </span>
                  </div>
                </VueNestableHandle>
              </template>
            </VueNestable>
          </div>
          <div v-else id="wrapper-empty" class="help-empty text-center">
            {{$t('engine.manageHeader.widgetTopMenu.manageMenu.lblHelpEmpty', languageEngine)}}
          </div>
        </div>
      </div>
    </b-modal>
    <AddMenu
      :action="action"
      :id="item_id"
      :isChild="isChild"
      @clear="(action = ''), (item_id = ''), (text = ''), (isChild = false)"
    />
    <ConfirmDelete
      :item_name="item_name"
      @confirmed="deleteItem(item_id)"
      :isChild="isChild"
      :isEnable="isEnable"
      @clear="(action = ''), (item_id = ''), (text = ''), (isChild = false), (isEnable = true)"
    />
  </fragment>
</template>

<script>
import { VueNestable, VueNestableHandle } from "vue-nestable";
import { mapGetters } from "vuex";
import AddMenu from "./AddTopMenu/AddTopMenu";
import ConfirmDelete from "./dialogConfirmDelete.vue";
import TitleModal from "@components_system/Shared/Elements/Texts/TitleModal";

export default {
  data() {
    return {
      text: "",
      item_id: "",
      expand_id: "",
      item_name: "",
      action: "add",
      isChild: false,
      countSearch: 0,
      hoverTool: false,
      isEnable: true,
    };
  },
  components: {
    VueNestable,
    VueNestableHandle,
    AddMenu,
    ConfirmDelete,
    TitleModal
  },
  computed: {
    ...mapGetters({
      languageEngine: "design/userPreference/languageEngine",
      languages: "design/site/languages",
      languageUse: "design/site/languageUse",
      siteComponents: "design/metadata/siteComponents",
      modal: "design/modal",
    }),
    displayData: {
      get() {
        let data = this.createdData();
        return this.text != "" ? this.filterText(data) : this.cleanFilterText(data);
      },
      set(value) {
        this.siteComponents.HEADER_WIDGET_TOPMENU.componentsID =
          this.sortingItems(value);
        this.$store.dispatch("design/snapshot/genSnapshot");
      },
    },
  },
  mounted() {
    this.$root.$on("bv::modal::shown", () => {
      const _vm = this;
      $(".modal").on("click", function (bvEvent) {
        if (
          _vm.expand_id &&
          bvEvent.target.className != "cursor-pointer tools-more-menu active"
        ) {
          _vm.$root.$emit("bv::hide::popover", _vm.expand_id);
          _vm.expand_id = "";
          _vm.enable();
        }
      });
    });
  },
  watch: {
    text() {
      this.countSearch = 0;
    },
    modal: {
      handler() {
        if (this.modal == "modal-manage-header-topmenu") {
          this.$bvModal.show("modal-manage-header-topmenu");
        }
      },
    },
  },
  methods: {
    closeModal() {
      this.$store.dispatch("design/setModal", { name: "" });
      this.$bvModal.hide("modal-manage-header-topmenu");
    },
    preventScroll(e) {
      e.preventDefault();
    },
    disable() {
      document
        .querySelector(".modal-body")
        .addEventListener("wheel", this.preventScroll);
    },
    enable() {
      document
        .querySelector(".modal-body")
        .removeEventListener("wheel", this.preventScroll, false);
    },
    fixExpand(item) {
      if (`tools${item.id}` === this.expand_id) {
        this.expand_id = "";
        this.enable();
      } else {
        this.expand_id = String(`tools${item.id}`);
        this.disable();
      }
    },
    addMenu() {
      this.action = "add";
      this.$bvModal.hide("modal-manage-header-topmenu");
      this.$bvModal.show("modal-addedit-header-topmenu");
    },
    editMenu(id, isChild, status) {
      this.item_id = id;
      this.action = "edit";
      this.isChild = isChild;
      this.isEnable = status;
      this.$bvModal.hide("modal-manage-header-topmenu");
      this.$bvModal.show("modal-addedit-header-topmenu");
    },
    confirmDelete(id) {
      this.item_id = id;
      this.item_name = this.siteComponents[id].properties.name;
      this.$bvModal.show("modal-confirm-delete-topmenu");
    },
    deleteItem(id) {
      this.text = "";
      const index =
        this.siteComponents.HEADER_WIDGET_TOPMENU.componentsID.findIndex(
          (item) => item === id
        );
      if (index !== -1) {
        this.siteComponents.HEADER_WIDGET_TOPMENU.componentsID.splice(index, 1);
        delete this.siteComponents[id];
      } else {
        Object.keys(this.siteComponents).map((item) => {
          if (
            this.siteComponents[item] &&
            this.siteComponents[item].type === "HEADER_MENU"
          ) {
            const index = this.siteComponents[item].componentsID.findIndex(
              (item) => item === id
            );
            if (index !== -1) {
              this.siteComponents[item].componentsID.splice(index, 1);
              delete this.siteComponents[id];
            }
          }
        });
      }
      this.snap();
      this.$toast.success({ title: this.$t("engine.common.alert.success.title", this.languageEngine), message: this.$t("engine.manageHeader.widhrTopMenu.AddEditMenu.msgDeletemenuSuccess", this.languageEngine) });
    },
    setStatus(id) {
      this.siteComponents[id].properties.isEnable = !this.siteComponents[id].properties.isEnable;
      this.$store.dispatch("design/snapshot/genSnapshot");
      this.$toast.success({ title: this.$t("engine.common.alert.success.title", this.languageEngine), 
        message: this.$t(`${this.siteComponents[id].properties.isEnable ? "engine.manageHeader.widhrTopMenu.AddEditMenu.msgShowmenuSuccess":"engine.manageHeader.widhrTopMenu.AddEditMenu.msgHidemenuSuccess"}`, this.languageEngine) 
      });
    },
    snap() {
      this.$store.dispatch("design/snapshot/genSnapshot");
    },
    deepCopy(obj) {
      return JSON.parse(JSON.stringify(obj));
    },
    checkShow(isShow = true) {
      if (this.text == "") {
        return true;
      } else {
        return isShow;
      }
    },
    createdData() {
      let data = [];
      this.siteComponents.HEADER_WIDGET_TOPMENU.componentsID.map((item) =>
        data.push(this.deepCopy(this.siteComponents[item]))
      );
      return data;
    },
    sortingItems(value) {
      let data = [];
      value.map((item) => data.push(item.id));
      return data;
    },
    cleanFilterText(arr) {
      this.countSearch = 0;
      return arr.map((item) => {
        item.show = false;
        return item;
      });
    },
    filterText(arr) {
      this.countSearch = 0
      return arr.map((item) => {
        if (item.properties.name) {
          if (item.properties.name.toLowerCase().search(this.text.toLowerCase()) > -1) {
            this.countSearch += 1;
            item.show = true;
          } else {
            item.show = false;
          }
        }
        return item;
      });
    },
  },
};
</script>

<style lang="scss">
#modal-manage-header-topmenu {
  .modal-header {
    padding: 16px 32px 24px 32px;
    .icon-question {
      font-size: 18px;
      width: 18px;
      height: 18px;
      color: rgba(0, 0, 0, 0.5);
      svg { 
        position: absolute;
      }
    }
    .icon-close-modal {
      font-size: 24px;
      width: 16px;
      height: 24px;
      color: rgba(0, 0, 0, 0.5);
      svg { 
        position: absolute;
      }
    }
    .modal-title {
      display: flex;
      align-items: center;
      .flag-icon {
        height: 16px;
        margin-top: -2px;
      }
    }
    .btn-add-menu {
      white-space: nowrap;
    }
    .wrapper-search {
      margin-left: 16px;
      width: 100%;
      height: 32px;
      position: relative;
      .icon-search svg {
        position: absolute; 
        left: 10px; 
        top: 50%;
        transform: translateY(-50%);
        font-size: 14px;
        color: #A5A5A5;
      }
      input {
        padding: 0 32px;
        height: 32px;
        font-family: 'Sarabun';
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
      }
      .icon-clear-text {
        position: absolute;
        right: 10px; 
        top: 50%;
        transform: translateY(-50%);
        cursor: pointer;
        font-size: 14px;
        color: #A5A5A5;
      }
    }
  }
  .modal-body {
    padding: 24px 30px;
    overflow-x: hidden;
    #nested-wrapper {
      .nestable-item .nestable-item-content .handler {
        &::before {
            transition: all 0.2s ease;
            content: '';
            height: 1px;
            width: 15px;
            background-color: #DFDFDF;
            position: absolute;
            top: 18px;
            left: -15px;
            margin: auto;
          }
          &::after {
              transition: all 0.2s ease;
              content: '';
              width: 1px;
              height: calc(100% + 10px);
              background-color: #DFDFDF;
              position: absolute;
              top: 0;
              bottom: 0;
              left: -15px;
              margin-top: -10px;
          }
      }
      .nestable-item:last-child  > .nestable-item-content .handler{
          &::after {
            transition: all 0.1s ease;
            height: 28px;
          }
      }
      .nestable-group > .nestable-item > .nestable-item-content .handler{
          &::before {
            display: none;
          }
          &::after {
            display: none;
          }
        }
        .nestable.pos-unset {
          position: unset;
          .nestable-item {
            position: unset;
            .nestable-item-content .handler::before,
            .nestable-item-content .handler::after {
              display: none;
            }
          }
        }
    }
    #panel-item {
      margin-top: 8px;
      margin-bottom: 8px;
      position: static;
      display: block;
      align-items: center;
      padding: 0 8px;
      height: 40px;
      background-color: #fff;
      border: 1px solid #DEE3E6;
      border-radius: 4px;
      transition: background-color 0.2s ease-out;
      cursor: pointer;
      &.disabled {
        color: #A5A5A5;
      }
      &.hover, &:hover {
        background: #F4FCFF;
        box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.075);
        outline: 1px solid var(--primary);
      }
      .tool {
        display: none;
      }
      .icon-drag {
        color: #DEE3E6 !important;
        font-size: 16px; 
        width: 16px; 
        height: 16px;
        cursor: move;
      }
      &:hover {
        .tool {
            display: block;
            margin-left: 8px;
            .btn {
              padding: 0px;
              border: 0px;
            }
            .option {
              &:hover {
                background-color: #f4fcff;
              }
            }
        }
        .icon-drag {
          color: #373E44 !important;
        }    
      }
      &.bactive.active , .bactive:active{
        .tool {
            display: block;
        }
      }
      .tools-more-menu {
        width: 20px;
        height: 20px;
        padding: 0;
        border-radius: 50%;
        background: transparent;
        border: none;
        text-align: center;
        outline: 1px solid #BDEBF6;
        &:hover {
          outline: 2px solid #BDEBF6;
        }
        &.active{
          outline: 2px solid #24BEE2;
        }
      }
      .popover {
        margin-top: -12px;
        margin-left: 14px;
        width: 150px;
        border: 1px solid #CED4DA;
        border-radius: 4px;
        box-shadow: 0px 16px 48px rgba(0, 0, 0, 0.176);
        background: #FFFFFF;
        .arrow {
          display: none;
        }
        .popover-body {
          padding: 10px 0;
          .option {
            color: #373E44;
            padding: 5px 20px;
          }
        }
      }
    }
    #wrapper-empty {
      margin-top: 9px;
      margin-bottom: 9px;
      position: relative;
      display: block;
      padding: .5rem .75rem .5rem .6rem;
      background-color: #fff;
      border: 1px solid var(--line);
      border-radius: 4px;
    }

  }


  .modal-content {
    overflow: unset !important;
  }
  ::-webkit-scrollbar {
    background-color: #fff;
    width: 16px;
  }
  ::-webkit-scrollbar-track {
    background-color: #fff;
  }
  ::-webkit-scrollbar-thumb {
    background-color: #babac0;
    border-radius: 16px;
    border: 4px solid #fff;
  }
  ::-webkit-scrollbar-button {
    display: none;
  }
}
#modal-manage-header-topmenu___BV_modal_body_ {
  position: static;
}
.modal-body.static .nestable,
.modal-body.static .nestable-item {
  position: static;
}
.modal-body.static .nestable-item .handler::before,
.modal-body.static .nestable-item .handler::after {
  display: none;
}
</style>
